import React, { useState, useEffect, useMemo } from 'react'
import { Select } from './Select'
import { NumberInput } from './NumberInput'

export const CardType = ({ field, onChange, value }) => {
  const onUpdateCardType = (val) => {
    const updatedValue = {
      ...value,
      name: val.value,
    }
    onChange(updatedValue)
  }

  const onUpdateCardTypeRange = (range, val) => {
    const updatedValue = {
      ...value,
      range: {
        ...value.range,
        [range]: parseInt(val, 10),
      },
    }
    onChange(updatedValue)
  }

  return (
    <div className='gap-8'>
      <Select
        label={'Card Type'}
        placeholder={''}
        selectedOption={field.options.find(option => option.value === (value?.name || 'filledCard'))}
        options={field.options}
        onChange={value => {
          onUpdateCardType(value)
        }}
      />
      {value?.name === 'indicator' && (
        <div className="chart-editor-border">
          <NumberInput
            key={field.id}
            label={'Range min'}
            value={value?.range.min}
            onChange={val => onUpdateCardTypeRange('min', val)}
          />
          <NumberInput
            key={field.id}
            label={'Range max'}
            value={value?.range.max}
            onChange={val => onUpdateCardTypeRange('max', val)}
          />
        </div>
      )}
    </div>
  )
}